import { AbstractFacade } from '@goparrot/axios';
import { plainToInstanceWithLVS } from '@goparrot/common';
import deepmerge from 'deepmerge';
import { ReadPromotionDto } from '../generated-dto';
import { PromotionExposeGroup } from '../interface';
export class MerchantPromotionFacade extends AbstractFacade {
    constructor(config = {}, interceptors = {}) {
        super(deepmerge.all([
            {
                axiosConfig: {
                    baseURL: process.env.GOPARROT_PLATFORM_SERVICE_PROMOTION,
                },
            },
            config,
        ]), interceptors);
    }
    async list(merchantId, types) {
        const { data: promotions } = await this.client.get(`/api/v2/merchants/${merchantId}/promotions`, {
            params: { type: types === null || types === void 0 ? void 0 : types.join('|') },
        });
        return plainToInstanceWithLVS(ReadPromotionDto, promotions, { groups: [PromotionExposeGroup.READ] });
    }
    async get(merchantId, uuid) {
        const { data: promotion } = await this.client.get(`/api/v2/merchants/${merchantId}/promotions/${uuid}`);
        return plainToInstanceWithLVS(ReadPromotionDto, promotion, { groups: [PromotionExposeGroup.READ] });
    }
    async getMany(merchantId, uuids) {
        const params = uuids.map((uuid) => `promotions[]=${uuid}`);
        const url = `/api/v2/merchants/${merchantId}/promotions/many?${params.join('&')}`;
        const { data: promotions } = await this.client.get(url);
        return plainToInstanceWithLVS(ReadPromotionDto, promotions, { groups: [PromotionExposeGroup.READ] });
    }
    async create(merchantId, data) {
        const { data: promotion } = await this.client.post(`/api/v2/merchants/${merchantId}/promotions`, data);
        return plainToInstanceWithLVS(ReadPromotionDto, promotion, { groups: [PromotionExposeGroup.READ] });
    }
    async update(merchantId, uuid, data) {
        const { data: promotion } = await this.client.put(`/api/v2/merchants/${merchantId}/promotions/${uuid}`, data);
        return plainToInstanceWithLVS(ReadPromotionDto, promotion, { groups: [PromotionExposeGroup.READ] });
    }
    async delete(merchantId, uuid) {
        await this.client.delete(`/api/v2/merchants/${merchantId}/promotions/${uuid}`);
    }
}
//# sourceMappingURL=MerchantPromotionFacade.js.map